import { SessionStorage } from 'app/storage/session.storage';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AssociationsService } from 'app/services/associations.service';
import { AssociationHelper } from 'app/storage/association.storage';
import { lastValueFrom } from 'rxjs';
import { MeetingFormService } from '../meeting-form.service';

@Component({
  selector: 'second-meeting',
  templateUrl: './second-meeting.component.html',
  styleUrls: ['./second-meeting.component.scss']
})
export class SecondMeetingComponent implements OnInit {

  form: FormGroup
  loading:boolean = true

  constructor(
    private fb: FormBuilder,
    private formService: MeetingFormService,
    private service: AssociationsService,
    private helper: AssociationHelper,
    private router: Router,
    public auth: SessionStorage
  ) {
    this.formService.clear() 
    this.form = this.fb.group({
      dateSetted: [false, Validators.required],
      date: ['', Validators.required],
      meetingCompleted: [false, Validators.required],
      /*
      "Question 1.2": new FormArray([]),
      "Question 2.2": ['', Validators.required],
      "Question 3.2": ['', Validators.required],
      "Question 45.2": new FormArray([])
      */
    })
    this.formService.setForm(this.form)
   }

  async ngOnInit(): Promise<void> {
    if(this.helper.getSelectedProject() == -1 || this.helper.getSelectedEpe() == -1){
      this.router.navigateByUrl(`assigned-services`)
    }
    
    let response = await lastValueFrom(this.service.getForm(this.helper.getSelectedProject(), this.helper.getSelectedEpe(), 2), {defaultValue: null})
    if(!response){
      this.loading = false
      return
    }
    let form: { [key: string]: any; } = response['meeting_form_2']
    let step = this.retrieveStep(form)
    
    this.formService.updateForm(form)
    this.formService.setStep(step)

    this.form.valueChanges.subscribe(data => console.log('Form changes', data));

    this.loading = false

    if(this.helper.getMeetingForm() > 2)
      this.router.navigateByUrl(`form/(meeting-form:meeting_2/(meeting_2:summary))`)
    else if (step > 0)
      this.router.navigateByUrl(`form/(meeting-form:meeting_2/(meeting_2:${this.formService.getStep(2)}))`)
  }

  private retrieveStep(form: { [key: string]: any; }): number{

    let keys = Object.keys(form)
    
    if(keys.indexOf('meetingCompleted') >= 0)
      return 2
    else if(keys.indexOf('date') >= 0)
      return 1
    return 0
  }

}
